export enum SortCards {
    DEFAULT = 'default',
    UP = 'up',
    DOWN = 'down',
    SUIT = 'suit'
}